import { OpenAPIConfig } from '../api';

export const apiConfig: Partial<OpenAPIConfig> = {
	BASE: process.env.REACT_APP_API_URL,
	HEADERS: {
		'X-Hmp-Country': process.env.REACT_APP_MARKET as string ?? "",
	}
};